var _style, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagFrance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 45",
    style: {
      enableBackground: "new 0 0 70 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-france{fill:#02377B;}\r\n\t.st1-france{fill:#FFFFFF;}\r\n\t.st2-france{fill:#F94A4A;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_505",
    className: "st0-france",
    width: 23.7,
    height: 45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_506",
    x: 23.7,
    className: "st1-france",
    width: 22.6,
    height: 45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_507",
    x: 46.3,
    className: "st2-france",
    width: 23.7,
    height: 45
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFrance);
export default __webpack_public_path__ + "static/media/FlagFrance.5d37a1f189fbe76923c0969512498d39.svg";
export { ForwardRef as ReactComponent };